import "./Blog.module.css";
import NavigationHeader from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import BlogPosts from "./sections/BlogPosts";
import NewsletterCallToAction from "./sections/NewsletterCallToAction";
import CustomerReviews from "@/pages/Home/sections/CustomerReviews";
import Footer from "@/reusable_sections/Footer";
export default function BlogPage() {
  return <div>
      <NavigationHeader />
      <Hero />
      <BlogPosts />
      <NewsletterCallToAction />
      <CustomerReviews />
      <Footer />
    </div>;
}